<template>
    <div class="fx-g1 fx-col" v-loading="loading" element-loading-text="数据拼命加载中...">
        <div class="item_block fx fx-m_between info_row ">
            <el-form :inline="true" :model="form" >
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item label="是否分享">
                    <el-select v-model="form.sharing" clearable  placeholder="是否分享">
                        <el-option label="是" value="true"></el-option>
                        <el-option label="否" value="false"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div >
                <el-button type="primary" size="medium" @click="editCodeBase({})">添加代码</el-button>
            </div>
        </div>
        <div class="panel_body ">
            <div v-for="codeBase in codeBases" :key="codeBase.id" class="item_block ">
                <div class="fx fx-c_center info_row" style="border-bottom: 1px solid var(--border)">
                    <!--<iframe src="" frameborder="0" v-if="codeBase.type != 2" @click="viewCode(codeBase.type, codeBase.codes[0].id)" style="width: 250px;height: 110px">
                        <div id="work_container">
                            <img :src="codeBase.codes[0] ? codeBase.codes[0].coverimg : ''" style="width: 100%;height: 100%">
                        </div>
                    </iframe>-->
                    <div class="coverimg" v-if="codeBase.type == 1"  style="width: 250px; height: 150px">
                        <el-image
                            style="width: 100%;height: 80%"
                            :src="codeBase.codes[0] ? codeBase.codes[0].coverImg : ''"
                            :lazy="true"
                            fit="contain"></el-image>
                    </div>
                    <div class="coverimg" v-if="codeBase.type == 2"  style="width: 250px; height: 150px">
                        <el-image
                            style="width: 100%;height: 80%"
                            src="http://assets.program.leadersir.cn/imgs/python_logo.jpeg"
                            :lazy="true"
                            fit="contain"></el-image>
                    </div>

                    <div style="width: 800px;" >
                        <div class="lesson_name">
                            {{codeBase.title}}
                            <span v-if="codeBase.sharing" style="margin-left:10px;">
                            <el-tag
                                type=""
                                effect="plain">
                                已分享
                            </el-tag>
                        </span>
                        </div>
                        <div class="" style="margin-top:5px;">
                            {{codeBase.content}}
                        </div>
                        <div class="fx fx-m_between fx-c_center lesson_resource" style="margin-top: 12px">
                            <!-- <span class="fx fx-c_center">视频:
                                <span v-if="codeBase.videos.length==0" class="text_info tip"> 未设置</span>
                                <el-link v-else type="primary" @click="setShowResources(lesson.videos)" :underline="false" class="font12"><i class="iconfont icon-shipin"></i>查看</el-link>
                            </span> -->
                            <span class="fx fx-c_center">代码:
                            <span v-if="codeBase.codes.length==0" class="text_info tip"> 未设置</span>
                            <el-link v-else type="primary" @click="viewCode(codeBase.type, codeBase.codes[0].id)" :underline="false" class="font12"><i class="iconfont icon-word"></i>查看</el-link>
                        </span>
                        </div>
                        <div style="margin-top: 12px">
                            <tag-group :tags="codeBase.tagArray" size="mini" style="justify-content: flex-start"></tag-group>
                        </div>
                    </div>
                    <div class="fx-g1"></div>
                    <div>
                        <div class="lesson_name fx fx-m_between fx-c_center">
                            <el-button @click="modifySharing(codeBase)" :type="codeBase.sharing ? 'info' : 'primary'" style="border-radius: 10px;margin-left: 55px;position: relative;top: -25px;">
                                {{codeBase.sharing ? '取消分享':'分享代码'}}
                            </el-button>
                        </div>
                        <div style="width: 160px" class="fx fx-m_between fx-c_center">
                            <el-link type="primary" @click="editCodeBase(codeBase)"
                                     :underline="false" ><i class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                            <el-popconfirm @onConfirm="delCodeBase(codeBase)"
                                           title="确认删除该代码库吗？"
                            >
                                <el-link type="danger" slot="reference"
                                         :underline="false" ><i class="iconfont icon-shanchu"></i><b>删除</b></el-link>
                            </el-popconfirm>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
        <ResourceDrawer :showBox="showResources" @play="play"
                        @close="showResources=false" label="资源列表" :resources="currentResources"></ResourceDrawer>
        <VideoDrawer v-if="showVideo" @close="showVideo=false" :url="currentVideo"></VideoDrawer>
        <CodeBaseEditDrawer v-if="showCodeBaseEdit" @submit="loadCodeBases"
                          @close="showCodeBaseEdit=false" :item="currentCodeBase"></CodeBaseEditDrawer>
    </div>
</template>

<style scoped>
    .panel_foot  {
        background-color: white;
    }
    .tip {
        padding:0 6px 0 12px;
    }
    .item_block {
        background: white;
        padding: 18px 50px;
        border-radius: 6px;
        margin-bottom: 10px;
    }
    .info_row>*:not(:first-child) {
        margin-left: 50px;
    }

    .coverimg {
        width: 160px;
    }
    .lesson_name {
        font-size: 16px;
        font-weight: bold;
        color: var(--dark);
    }
    .lesson_resource i.iconfont, .task_info i.iconfont {
        vertical-align: text-bottom;
    }

    .task_item {
        height: 50px;
        border-bottom: 1px solid var(--border);
    }
</style>
<style>

</style>
<script type="text/javascript" src="http://assets.program.leadersir.cn/scratch/lib.min.js" ></script>
<script type="text/javascript" src="http://assets.program.leadersir.cn/scratch/chunks/player.js" ></script>
<script>
    import ResourceDrawer from '@/components/ResourceDrawer';
    import VideoDrawer from '@/components/VideoDrawer';
    import CodeBaseEditDrawer from "./CodeBaseEditDrawer";
    export default {
        components: {
            ResourceDrawer,
            VideoDrawer,
            CodeBaseEditDrawer
        },
        props: [
        ],
        data() {
            return {
                loading: true,
                showResources: false,
                currentResources: [],
                showVideo: false,
                currentVideo: null,
                showEdit: false,
                showCodeBaseEdit: false,
                currentCodeBase: {},
                form:{keywords:''},
                codeBases: [],
                 pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                 },
            }
        },
        watch: {
            "form": {
                handler: function () {
                    //查询条件变了
                    this.loadCodeBases();
                },
                deep: true
            }
        },
        methods: {
            //加载单节课
            loadCodeBase(codeBase) {
                if(codeBase != undefined){
                    codeBase.codes = codeBase.resources.filter(r => r.category == 4);
                    codeBase.tasks = [];
                    this.codeBases.push(codeBase);
                }
                this.showCodeBaseEdit = false;
            },
            //加载所有课
            loadCodeBases() {
                this.$ajaxPost("/codeBase/list",{form : this.form,pager: {...this.pager, dataTotal: 0}}, (data) => {
                    let codeBases = data.result;
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    codeBases.forEach(item => {
                        item.codes = item.resources.filter(r => r.category == 4);
                    })
                    this.showCodeBaseEdit = false;
                    this.codeBases = codeBases;
                    this.loading = false;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadCodeBases();
            },
            editCodeBase(item) {
                this.currentCodeBase = {...item, lessonSystemId: ''};
                this.showCodeBaseEdit = true;
            },

            delCodeBase(codeBase) {
                this.$ajaxGet("/codeBase/del/" + codeBase.id, (data) => {
                    this.codeBases = this.codeBases.filter(item => item != codeBase);
                })
            },

            modifySharing(item) {
                this.$ajaxGet("/codeBase/toggleSharing/" + item.id + "-" + !item.sharing);
                let codeBase = this.codeBases.filter(codebase => codebase.id == item.id);
                codeBase[0].sharing = !codeBase[0].sharing;
            },
            setShowResources(resources) {
                this.currentResources = resources;
                this.showResources = true;
            },
            play(url) {
                this.currentVideo = url;
                this.showVideo = true;
            },
            viewCode(codeBaseType, id) {
                this.$goEditCode(codeBaseType, `mode=caseview&id=${id}`);
            }
        },
        created() {
            this.loadCodeBases();
        }
    }
</script>
